<script setup lang="ts">
import { onMounted, ref } from 'vue'

const chartOptions = ref({
  labels: ["Người dùng nam", "Người dùng nữ"]
})
const series = ref([11, 32])
</script>

<template>
  <apexchart
    ref="donut"
    width="100%"
    type="donut"
    :options="chartOptions"
    :series="series"
  ></apexchart>
</template>

<style scoped>

</style>
